import { createRouter, createWebHistory } from "vue-router";
import { usePostHog } from '@/composables/usePostHog';

const routes = [
  {
    path: "/",
    name: "Discover",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Discover/index.vue"),
  },
  {
    path: "/filters",
    name: "Filters",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Filters.vue"),
  },
  {
    path: "/menu",
    name: "HeaderResponsive",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HeaderResponsive.vue"),
  },
  {
    path: "/hooks",
    name: "Hooks",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Hooks/index.vue"),
  },
  {
    path: "/visual-hooks",
    name: "VisualHooks",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Hooks/VisualHooks.vue"),
  },
  {
    path: "/verbal-hooks",
    name: "VerbalHooks",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Hooks/VerbalHooks.vue"),
  },
  {
    path: "/calendar",
    name: "Calendar",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Calendar/index.vue"),
  },
  {
    path: "/frameworks",
    name: "frameworks",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Hooks/index.vue"),
  },
  {
    path: "/favorites",
    name: "Favorites",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Favorites/index.vue"),
  },
  {
    path: "/top-brands",
    name: "top-brands",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/TopBrands/index.vue"),
  },
  {
    path: "/psychology",
    name: "Psychology",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Psychology/index.vue"),
  },
  {
    path: "/psychology/1",
    name: "Tips1",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Psychology/Tips.vue"),
  },
  {
    path: "/psychology/2",
    name: "Tips2",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Psychology/Tips2.vue"),
  },
  {
    path: "/case-studies",
    name: "CaseStudies",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CaseStudies/index.vue"),
  },
  {
    path: "/case-studies/:id",
    name: "CaseStudyInfo",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/CaseStudies/CaseStudyInfo.vue"
      ),
  },
  {
    path: "/tiktoks",
    name: "Tiktoks",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Tiktoks/index.vue"),
  },
  {
    path: "/ads-test-first",
    name: "AdsTestFirst",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AdsTestFirst/index.vue"),
  },
  {
    path: "/discover",
    name: "discover",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Discover/index.vue"),
    children: [
      {
        path: "ads/:id",
        name: "LibraryId",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Library/Id.vue"),
      },
    ],
  },
  {
    path: "/deals-and-tools",
    name: "Deals and tools",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Directory/index.vue"),
  },
  {
    path: "/ugc-creators",
    name: "UGC Creators",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/UGCCreators/index.vue"),
  },
  {
    path: "/ugc-creator-info",
    name: "UGC Creator Info",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/UGCCreators/UGCCreatorInfo.vue"
      ),
  },
  {
    path: "/our-process",
    name: "OurProcess",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/OurProcess/index.vue"),
  },
  {
    path: "/no-visibles",
    name: "NoVisibles",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/NoVisibles.vue"),
  },
  {
    path: "/thank-you",
    name: "Thanks",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/thanks.vue"),
  },
  {
    path: "/pricing",
    name: "Pricing",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Pricing.vue"),
  },
  {
    path: "/account",
    name: "Account",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Account/index.vue"),
    children: [
      {
        path: "",
        name: "AccountSetting",
        component: () =>
          import(
            /* webpackChunkName: "setting" */ "../views/Account/Setting.vue"
          ),
      },
      {
        path: "subscription",
        name: "AccountSubscription",
        component: () =>
          import(
            /* webpackChunkName: "setting" */ "../views/Account/Subscription.vue"
          ),
        children: [
          {
            path: "",
            name: "HomeMembership",
            component: () =>
              import(
                /* webpackChunkName: "setting" */ "../views/Account/Membership/index.vue"
              ),
          },
          {
            path: "repay",
            name: "RepayMembership",
            component: () =>
              import(
                /* webpackChunkName: "setting" */ "../views/Account/Membership/Repay.vue"
              ),
          },
        ],
      },
      {
        path: "support",
        name: "AccountSupport",
        component: () =>
          import(
            /* webpackChunkName: "setting" */ "../views/Account/Support.vue"
          ),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Initialize PostHog
const { posthog } = usePostHog();

// Track pageviews on route changes
router.afterEach((to) => {
  posthog.capture('$pageview', {
    $current_url: window.location.href,
    path: to.path,
    name: to.name,
  });
});

export default router;
